import { Close } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import useSelectedFilesPreviewStyles from './useSelectedFilesPreviewStyles';

interface SelectedFilesPreviewProps {
  files: FileList;
  removeFile: (index: number) => void;
}

const SelectedFilesPreview = (props: SelectedFilesPreviewProps) => {
  const { files, removeFile } = props;
  const classes = useSelectedFilesPreviewStyles();
  const filesArray = files ? Array.from(files) : [];

  return (
    <Stack sx={classes.attachmentsPreviewContainer}>
      {filesArray?.map((a, i) => (
        <Stack key={a?.name} sx={classes.attachmentListItemPreviewContainer}>
          <Typography sx={classes.fileNameText}>{a?.name}</Typography>
          <IconButton
            size="small"
            sx={classes.crossIcon}
            onClick={() => removeFile(i)}
          >
            <Close fontSize="small" />
          </IconButton>
        </Stack>
      ))}
    </Stack>
  );
};

export default SelectedFilesPreview;
